import { isManagedUserAccount } from './accessControl'
import { UserRoleType } from '../types/activity_user'

import api from './api'

export const PLATFORM_DEFAULT_VOICE_CALLER_LABEL = 'Platform default'

export const isEligibleForPrivateNumberRequest = (user) => {
  if (!user) return false
  if (isManagedUserAccount(user)) return false
  return user.user_type === UserRoleType.service_provider
}

export const getVoiceCallerRequestsKey = (statusFilter = 'all') => {
  if (statusFilter === 'all') return 'voice-caller-number-requests/'
  return `voice-caller-number-requests/${statusFilter}/`
}

export const normalizeVoiceCallerRequests = (data) => {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.results)) return data.results
  return []
}

export const getVoiceCallerRequestNumber = (request) =>
  request?.phone_number ||
  request?.caller_number ||
  request?.private_number ||
  request?.number ||
  null

export const getVoiceCallerRejectionNotes = (request) =>
  request?.admin_notes || request?.rejection_reason || null

export const getAssignedVoiceCallerNumber = (data) => {
  if (!data || typeof data !== 'object') return null

  const number =
    data.effective_phone_number ||
    data.phone_number ||
    data.caller_number ||
    null

  if (data.uses_platform_default === true && !number) {
    return {
      number: null,
      usesPlatformDefault: true,
      detail: data.detail || 'No private voice caller number assigned yet.',
    }
  }

  return {
    number,
    usesPlatformDefault: Boolean(data.uses_platform_default),
    detail: data.detail || null,
  }
}

export const formatVoiceCallerApiError = (error, fallback = 'Something went wrong.') => {
  const data = error?.response?.data
  if (!data) return fallback
  if (typeof data === 'string') return data
  if (data.detail) return data.detail
  if (data.message) return data.message
  return fallback
}

export const hasPendingVoiceCallerRequest = (requests = []) =>
  requests.some((request) => (request?.status || '').toLowerCase() === 'pending')

export const hasAssignedPrivateVoiceNumber = (assignment) =>
  Boolean(assignment?.number && !assignment?.usesPlatformDefault)

export const fetchAssignedVoiceCallerNumber = async () => {
  try {
    const { data } = await api.get('voice-caller-numbers/mine/')
    return getAssignedVoiceCallerNumber(data)
  } catch (error) {
    if (error?.response?.status === 404) {
      return getAssignedVoiceCallerNumber({
        detail: 'No private voice caller number assigned yet.',
        effective_phone_number: null,
        uses_platform_default: true,
      })
    }
    throw error
  }
}
